// extracted by mini-css-extract-plugin
export default {"wrapper":"webcams-interactive-module--wrapper--769b9"};